import React from 'react';

import type { messages } from '../../../../i18n/messages';
import { CustomerService } from './customerService/CustomerService';
import { FAQList } from './faqList/FAQList';
import type { FormattedMessageDictionary } from '@/@types/FormattedMessageValue';

const styles = {
  faqTab: { maxWidth: 530 },
};

type FAQTabProps = {
  benefit: keyof (typeof messages)['de-DE']['benefits'];
  values?: FormattedMessageDictionary;
  includeCustomerService?: boolean;
};

export const FAQTab = ({ benefit, values, includeCustomerService = true }: FAQTabProps) => {
  return (
    <div style={styles.faqTab}>
      <FAQList benefit={benefit} values={values} />
      {includeCustomerService && <CustomerService />}
    </div>
  );
};

FAQTab.displayName = 'FAQTab';
